import {addQueryArgs} from '@wordpress/url';
import {getParamsOfUrl, getUrl} from '../mixins/search';
import {getWishListCookie} from './toggle-wishlist';
import {setCookie} from '../../mixins/cookie';

const wishlistNode = document.querySelector('#beposmna-wishlist');
const wishListTitleNode = wishlistNode.querySelector('.beposmna-wishlist-title');
const containerNode = wishlistNode.querySelector('.beposmna-listing-container');

const messagePopup = document.querySelector('#beposmna-snackbar');
const {__} = wp.i18n;
let popupTimeout;

//-----------
const restNamespace = BEPOSMNA_GLOBAL_OBJECT.rest_namespace || '';
const defaultQuery = {orderby: 'name', order: 'asc'};
let query = {};
let nextPage = null;
const userId = BEPOSMNA_GLOBAL_OBJECT.user_id || '';

const beposmnaListListing = () => {
    if (!containerNode) {
        return;
    }
    const queryParams = getParamsOfUrl();
    if (Object.keys(queryParams).length) {
        query = {...query, ...queryParams};
    }

    if (!userId) {
        const listingIds = getWishListCookie();
        query = {...query, post_in: listingIds};
    }

    getListings(query);
    pagination();
    removeWishList();
};

const getListings = (queryParam = {}) => {
    containerNode.style.opacity = 0.4;

    const param = {...defaultQuery, ...queryParam};
    wp.apiFetch({
        path: addQueryArgs('/' + restNamespace + '/wishlist', param), method: 'GET',
    }).then((res) => {
        if (res.data.content !== undefined) {
            containerNode.innerHTML = res.data.content;
        } else {
            if (res.msg) {
                containerNode.innerHTML = `<p>${res.msg}</p>`;
            }
        }
        renderPagination(res);
    }).catch((err) => {
        console.log(err);
    }).finally(() => {
        if (!userId) {
            delete query.post_in;
        }

        containerNode.style.opacity = 1;
    });
};

const renderPagination = (res) => {
    if (res.data.pagination !== undefined) {
        wishlistNode.querySelector('.beposmna-pagination').innerHTML = res.data.pagination;
    } else {
        wishlistNode.querySelector('.beposmna-pagination').innerHTML = '';
    }

    if (res.data.from_to !== undefined) {
        wishlistNode.querySelector('.beposmna-from-to').innerHTML = res.data.from_to;
    } else {
        wishlistNode.querySelector('.beposmna-from-to').innerHTML = '';
    }
};

const pagination = () => {
    document.addEventListener('click', function (event) {
        const target = event.target;
        const item = target.closest('a');
        if (!item) {
            return;
        }

        if (!item.getAttribute('data-page')) {
            return;
        }

        const paginationNode = target.closest('.beposmna-pagination');
        if (!paginationNode) {
            return;
        }
        event.preventDefault();
        const page = item.getAttribute('data-page');
        query = {...query, page};
        getListings(query);
        wishListTitleNode.scrollIntoView({behavior: 'smooth'});
    });
};


const removeWishList = () => {
    document.addEventListener('click', function (event) {
        const wishListNodes = containerNode.querySelectorAll('.beposmna-listing-wishlist');

        if (!wishListNodes) {
            return;
        }
        for (let i = 0; i < wishListNodes.length; i++) {
            const wishListNode = wishListNodes[i];
            if (wishListNode.contains(event.target)) {
                let listingId = wishListNode.getAttribute('data-listing-id');
                listingId = parseInt(listingId);
                wishListNode.disabled = true;
                if (userId) {
                    const data = {listing_id: listingId};
                    wp.apiFetch({
                        path: '/' + restNamespace + '/wishlist', method: 'POST', data,
                    }).then((res) => {
                        if (res.status === 'success') {
                            wishListNode.classList.toggle('active');
                        }

                        messagePopup.innerHTML = __('Đã được xóa khỏi danh sách yêu thích.', 'beposmna');
                        displayMessagePopup();
                        if (Object(query, 'page')) {
                            delete query.page;
                        }
                        getListings(query);
                    }).catch((err) => {
                        console.log(err);
                    }).finally(() => {
                        wishListNode.disabled = false;
                    });
                } else {
                    let listingIds = getWishListCookie();
                    if (listingIds && listingIds.includes(listingId)) {
                        //Remove wishlist listing
                        listingIds = listingIds.filter((item) => item !== listingId);
                        messagePopup.innerHTML = __('Đã được xóa khỏi danh sách yêu thích.', 'beposmna');
                    }

                    setCookie('beposmna_wishlist_listing', listingIds.join(','), 30);

                    displayMessagePopup();

                    const query = {
                        post_in: listingIds,
                    };

                    getListings(query);
                }
            }
        }
    });
};

const displayMessagePopup = () => {
    messagePopup.classList.add('active');

    if (popupTimeout) {
        clearTimeout(popupTimeout);
    }

    popupTimeout = setTimeout(() => {
        messagePopup.classList.remove('active');
        messagePopup.innerHTML = '';
    }, '3000');
};

export default beposmnaListListing;
